<template>
  <div class="page__flash_sale a-page">
    <div style="background-color:white; padding: 15px 20px; border-radius: 4px; overflow: hidden">
      <el-tabs v-model="tab">
        <el-tab-pane :label="$t('center.customer_insights_of_products')" name="by_product">
        </el-tab-pane>

        <el-tab-pane :label="$t('center.customer_insights_of_all_products')" name="by_shop">
        </el-tab-pane>
      </el-tabs>

      <div v-if="tab === 'by_product'">
        <el-row style="margin-top: 40px;">
          <el-col :sm="10">
            <div style="display: inline-block; margin-right: 10px">
              <shop-select v-model="shopee_shop.selected" :shopee_shop_list="shopee_shop.list"
                           :disabled="loading.get_data || loading.buy_together || loading.all_data"></shop-select>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <el-button v-if="shopee_shop.selected" size="small" type="primary" icon="el-icon-plus"
                         @click="show_dialog.select_product = true">
                {{ $t('center.select_product_to_analyze') }}
              </el-button>
            </div>
          </el-col>
          <el-col :sm="14" class="text-right">
            <div v-if="shop && shop.extra_data && shop.extra_data.linked && shop.extra_data.sync"
                 style="font-size: 15px; font-weight: 700;" class="text-primary">
              <i class="el-icon-loading"></i> {{ $t('center.shop_in_sync_orders_process') }}...
            </div>
          </el-col>
        </el-row>

        <div style="margin-top: 50px">
          <div v-if="!shop._id"
               style="width: 100%; height: 60px; line-height: 56px; border: 2px solid #ccccd6; border-radius: 50px; text-align: center; font-size: 15px; font-weight: 700;">
            {{ $t('center.select_shop_to_use_feature') }}.
          </div>

          <div v-else-if="shop.extra_data && !shop.extra_data.linked"
               style="width: 100%; height: 60px; line-height: 56px; border: 2px solid #ccccd6; border-radius: 50px; text-align: center; font-size: 15px; font-weight: 700;">
            {{ $t('center.shop_need_to_link') }}.
            <a href="javascript:void(0)" style="font-size: 15px; text-decoration: underline !important;"
               @click="m__get_login">
              {{ $t('center.link_account') }}.</a>
          </div>

          <div v-else-if="loading.get_data"
               style="width: 100%; height: 60px; line-height: 56px; border: 2px solid #ccccd6; border-radius: 50px; text-align: center; font-size: 15px; font-weight: 700;">
            <i class="el-icon-loading"></i> {{ $t('center.analyzing_data') }}...
          </div>

          <div v-else>
            <table class="table" v-if="selected_product.name">
              <tbody>
              <tr>
                <td style="width: 70px">
                  <div style="width: 70px; height: 70px">
                    <img style="width: 100%; height: 100%; object-fit: contain"
                         :src="SHOPEE_IMAGE(selected_product.image)" alt="">
                  </div>
                </td>
                <td>
                  <div style="padding-left: 20px">
                    <p style="font-size: 18px; font-weight: bold"
                       @click="open_link_fixed(`https://shopee.com/product-i.${shop.shop_id}.${selected_product.itemid}`, shop)">
                      {{ selected_product.name }}
                    </p>
                    <div style="font-size: 13px; font-weight: 600; margin-top: 10px">
                      {{ $t('base.stock') }}: {{ selected_product.stock }}
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      {{ $t('base.sold') }}: {{ selected_product.sold }}
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      {{ $t('base.sales') }}: {{ selected_product.gmv | currency }}
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      {{ $t('metric.impressions') }}: {{ selected_product.impression }}
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
            <div v-if="selected_model_list.length > 1">
              <div style="display: flex; gap: 10px; margin-bottom: 10px; font-weight: bold; align-items: center">
                <div style="width: 40px; max-width: 40px">
                  #
                </div>
                <div style="width: 200px; max-width: 200px">
                  {{ $t('base.variations') }}
                </div>
                <div style="width: 150px; max-width: 150px">
                  {{ $t('base.stock') }}
                </div>
                <template v-if="show_full_model_field">
                  <div style="width: 150px; max-width: 150px">
                    {{ $t('center.order_number') }}
                  </div>
                  <div style="width: 150px; max-width: 150px">
                    GMV
                  </div>
                  <div style="width: 150px; max-width: 150px">
                    AOV
                  </div>
                  <div style="width: 150px; max-width: 150px">
                    {{ $t('center.retail_gmv') }}
                  </div>
                  <div style="width: 150px; max-width: 150px">
                    {{ $t('center.bundled_gmv') }}
                  </div>
                </template>
              </div>

              <div v-for="model in selected_model_list"
                   style="display: flex; gap: 10px; margin-bottom: 10px; align-items: center">
                <div style="width: 40px; max-width: 40px">
                  <el-checkbox v-model="model.checked" style="margin-bottom: 0"></el-checkbox>
                </div>
                <div style="width: 200px; max-width: 200px">
                  {{ model.name }}
                </div>
                <div style="width: 150px; max-width: 150px">
                  {{ model.normalStock }}
                </div>
                <template v-if="show_full_model_field">
                  <div style="width: 150px; max-width: 150px">
                    {{ model.count | currency }}
                  </div>
                  <div style="width: 150px; max-width: 150px">
                    {{ model.gmv | currency }}
                  </div>
                  <div style="width: 150px; max-width: 150px">
                    {{ model.aov | currency }}
                  </div>
                  <div style="width: 150px; max-width: 150px">
                    {{ model.gmv_single | currency }}
                  </div>
                  <div style="width: 150px; max-width: 150px">
                    {{ model.gmv_together | currency }}
                  </div>
                </template>
              </div>
            </div>

            <el-row style="margin-top: 50px;">
              <el-col :sm="24">
                <div style="display: inline-block;">
                  <strong style="font-size: 13px">{{ $t('select.time_period_for_analysis') }}</strong>
                  <br>
                  <br>
                  <el-select size="small" value="" filterabl v-model="selected_period"
                             :placeholder="$t('input.time')" :disabled="loading.buy_together">
                    <el-option value="year" :label="$t('center.since_begin_year')"></el-option>
                    <el-option value="month" :label="$t('center.since_begin_month')"></el-option>
                    <el-option value="year_only" :label="$t('center.only_in_year')"></el-option>
                    <el-option value="month_only" :label="$t('center.only_in_month')"></el-option>
                    <el-option value="all" :label="$t('center.up_to_now')"></el-option>
                    <el-option value="month_range" :label="$t('center.from_month_to_month')"></el-option>
                    <el-option value="from_to" :label="$t('day.from_to')"></el-option>
                    <el-option value="past1week" :label="$t('base.past1week')"></el-option>
                    <el-option value="past1month" :label="$t('base.past1month')"></el-option>
                  </el-select>
                </div>
                <div v-if="!array_to_set(['past1week', 'past1month']).has(selected_period)"
                     style="display: inline-block; margin-right: 10px">
                  <el-date-picker
                    v-model="period_value"
                    :type="period_format[selected_period].key"
                    :format="period_format[selected_period].format"
                    :picker-options="{firstDayOfWeek: 1}"
                    :placeholder="$t('input.select_time')"
                    :start-placeholder="$t('base.select_start_time')"
                    :end-placeholder="$t('base.select_end_time')"
                    size="small"
                    :disabled="loading.get_data || loading.buy_together || array_to_set(['all', 'past1week', 'past1month']).has(selected_period)">
                  </el-date-picker>
                </div>
                <el-button size="small" type="primary" icon="el-icon-search" :loading="loading.buy_together"
                           @click="m__get_data">{{ $t('base.analyze_data') }}
                </el-button>
              </el-col>
            </el-row>

            <el-row style="margin-top: 60px">
              <el-col :sm="12" style="padding-right: 30px">
                <p style="font-size: 16px; font-weight: 600">
                  {{ $t('center.top_5_add_on_products_with_highest_gmv') }}</p>
                <el-table :data="top_5_by_gmv" v-loading="loading.buy_together"
                          row-key="id" default-expand-all class="table-hide-expand">
                  <el-table-column width="50px" fixed="left">
                    <template slot-scope="scope">
                      <img v-if="scope.row.is_parent" :src="SHOPEE_IMAGE(scope.row.images[0])" alt="logo"
                           style="width:40px; height: 40px; object-fit: contain">
                    </template>
                  </el-table-column>
                  <el-table-column show-tooltip-when-overflow fixed="left" :label="$t('base.product')">
                    <template slot-scope="scope">
                      <a v-if="scope.row.is_parent" href="javascript:void(0)"
                         @click="open_link_fixed(`https://shopee.com/product-i.${shop.shop_id}.${scope.row.id}`, shop)">
                        {{ scope.row.name }}
                      </a>
                      <span v-else>
                        {{ scope.row.name }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('base.sales')" prop="gmv" sortable>
                    <template slot-scope="scope">
                      {{ scope.row.gmv | currency }}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('base.buyers')" prop="buyers" sortable>
                    <template slot-scope="scope">
                      {{ scope.row.buyers | currency }}
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :sm="12" style="padding-left: 30px">
                <p style="font-size: 16px; font-weight: 600">{{
                    $t('center.top_5_add_on_products_with_most_buyers')
                  }}</p>
                <el-table :data="top_5_by_buyers" v-loading="loading.buy_together"
                          row-key="id" default-expand-all class="table-hide-expand">
                  <el-table-column width="50px" fixed="left">
                    <template slot-scope="scope">
                      <img v-if="scope.row.is_parent" :src="SHOPEE_IMAGE(scope.row.images[0])" alt="logo"
                           style="width:40px; height: 40px; object-fit: contain">
                    </template>
                  </el-table-column>
                  <el-table-column show-tooltip-when-overflow fixed="left" :label="$t('base.product')">
                    <template slot-scope="scope">
                      <a v-if="scope.row.is_parent" href="javascript:void(0)"
                         @click="open_link_fixed(`https://shopee.com/product-i.${shop.shop_id}.${scope.row.id}`, shop)">
                        {{ scope.row.name }}
                      </a>
                      <span v-else>
                        {{ scope.row.name }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('base.buyers')" prop="buyers" sortable>
                    <template slot-scope="scope">
                      {{ scope.row.buyers | currency }}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('base.sales')" prop="gmv" sortable>
                    <template slot-scope="scope">
                      {{ scope.row.gmv | currency }}
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>

            <el-row style="margin-top: 60px">
              <el-col :sm="12" style="padding-right: 30px">
                <p style="font-size: 16px; font-weight: 600">{{ $t('center.top_5_city_with_highest_gmv') }}</p>
                <el-table :data="top_by_gmv" v-loading="loading.buy_together">
                  <el-table-column :label="$t('center.province_city')" prop="state">
                    <template slot-scope="scope">
                      {{ scope.row.state }}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('base.sales')" prop="gmv" sortable>
                    <template slot-scope="scope">
                      {{ scope.row.gmv | currency }}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('base.buyers')" prop="buyers" sortable>
                    <template slot-scope="scope">
                      {{ scope.row.buyers | currency }}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('center.order_number')" prop="orders" sortable>
                    <template slot-scope="scope">
                      {{ scope.row.orders | currency }}
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :sm="12" style="padding-left: 30px">
                <p style="font-size: 16px; font-weight: 600">{{ $t('center.top_5_city_with_most_buyers') }}</p>
                <el-table :data="top_by_buyers" v-loading="loading.buy_together">
                  <el-table-column :label="$t('center.province_city')" prop="state"></el-table-column>
                  <el-table-column :label="$t('base.buyers')" prop="buyers" sortable>
                    <template slot-scope="scope">
                      {{ scope.row.buyers | currency }}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('base.sales')" prop="gmv" sortable>
                    <template slot-scope="scope">
                      {{ scope.row.gmv | currency }}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('center.order_number')" prop="orders" sortable>
                    <template slot-scope="scope">
                      {{ scope.row.orders | currency }}
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>

            <div style="margin-top: 60px">
              <el-row style="margin-bottom: 10px">
                <el-col :sm="20">
                  <p style="font-size: 16px; font-weight: 600">{{ $t('center.list_of_add_on_products') }}</p>
                </el-col>
                <el-col :sm="4">
                  <el-input size="mini" v-model="buy_together_filter.keyword"
                            :placeholder="$t('input.placeholder')"></el-input>
                </el-col>
              </el-row>
              <el-table :data="product_together_display_list" v-loading="loading.buy_together"
                        row-key="id" default-expand-all class="table-hide-expand"
                        @sort-change="m__buy_together_sort_change">
                <el-table-column width="60px" fixed="left" label="#">
                  <template slot-scope="scope">
                    <img v-if="scope.row.images" :src="SHOPEE_IMAGE(scope.row.images[0])" alt="logo"
                         style="width:45px; height: 45px; object-fit: contain">
                  </template>
                </el-table-column>
                <el-table-column :label="$t('base.product')" show-tooltip-when-overflow fixed="left" width="280px"
                                 show-overflow-tooltip>
                  <template slot-scope="scope">
                    <a v-if="scope.row.is_parent" href="javascript:void(0)"
                       @click="open_link_fixed(`https://shopee.com/product-i.${shop.shop_id}.${scope.row.item_id}`, shop)">
                      {{ scope.row.name }}
                    </a>
                    <span v-else>
                      {{ scope.row.name }}
                    </span>
                    <div style="height: 5px"></div>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('center.purchased_number')" prop="buy_together" sortable="custom"
                                 width="150px">
                  <template slot-scope="scope">
                    {{ scope.row.buy_together | currency }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('base.sales')" prop="gmv" sortable="custom" width="150px">
                  <template slot-scope="scope">
                    {{ scope.row.gmv | currency }}
                  </template>
                </el-table-column>
                <el-table-column label="AOV" prop="aov" sortable="custom" width="150px">
                  <template slot-scope="scope">
                    {{ scope.row.aov | currency }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('base.buyers')" prop="buyers" sortable="custom" width="150px">
                  <template slot-scope="scope">
                    {{ scope.row.buyers | currency }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('center.return_buyers')" prop="exist_buyers" sortable="custom"
                                 width="150px">
                  <template slot-scope="scope">
                    {{ scope.row.exist_buyers | currency }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('center.items_sold_order')" prop="items_per_order" sortable="custom"
                                 width="150px">
                  <template slot-scope="scope">
                    {{ scope.row.items_per_order | currency }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('center.highest_purchase_time')" prop="items_per_order" sortable="custom"
                                 width="150px">
                  <template slot-scope="scope">
                    <template v-if="scope.row.is_parent">
                      {{ scope.row.top_hour }} {{ $t('base.hours') }}
                    </template>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('center.city_with_most_buyers')" show-overflow-tooltip width="150px">
                  <template slot-scope="scope">
                    <template v-if="scope.row.is_parent">
                      {{ scope.row.top_state }}
                    </template>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                :current-page.sync="buy_together_filter.current_page"
                :page-size="buy_together_filter.page_size"
                layout="total, prev, pager, next"
                :total="product_together_filter_list.length">
              </el-pagination>
            </div>

            <div style="margin-top: 60px">
              <el-row style="margin-bottom: 10px">
                <el-col :sm="20">
                  <p style="font-size: 16px; font-weight: 600">{{ $t('center.shop_analysis_by_city') }}</p>
                </el-col>
                <el-col :sm="4">
                  <el-input size="mini" v-model="top_by_state_filter.keyword"
                            :placeholder="$t('input.placeholder')"></el-input>
                </el-col>
              </el-row>
              <el-table :data="top_by_state_display_list" v-loading="loading.buy_together"
                        @sort-change="m__top_state_sort_change">
                <el-table-column :label="$t('center.province_city')" prop="state"></el-table-column>
                <el-table-column :label="$t('base.sales')" prop="gmv" sortable>
                  <template slot-scope="scope">
                    {{ scope.row.gmv | currency }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('base.buyers')" prop="buyers" sortable="custom">
                  <template slot-scope="scope">
                    {{ scope.row.buyers | currency }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('center.return_buyers')" prop="exist_buyers" sortable="custom">
                  <template slot-scope="scope">
                    {{ scope.row.exist_buyers | currency }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('center.order_number')" prop="orders" sortable="custom">
                  <template slot-scope="scope">
                    {{ scope.row.orders | currency }}
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                :current-page.sync="top_by_state_filter.current_page"
                :page-size="top_by_state_filter.page_size"
                layout="total, prev, pager, next"
                :total="top_by_state_filter_list.length">
              </el-pagination>
            </div>

            <div style="margin-top: 60px">
              <p style="font-size: 16px; font-weight: 600">{{ $t('center.shop_analysis_by_period') }}</p>
              <el-table :data="top_by_hour" v-loading="loading.buy_together">
                <el-table-column :label="$t('base.period')">
                  <template slot-scope="scope">
                    {{ scope.row.label }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('base.sales')" prop="gmv" sortable>
                  <template slot-scope="scope">
                    {{ scope.row.gmv | currency }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('base.buyers')" prop="buyers" sortable>
                  <template slot-scope="scope">
                    {{ scope.row.buyers | currency }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('center.order_number')" prop="orders" sortable>
                  <template slot-scope="scope">
                    {{ scope.row.orders | currency }}
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div style="margin-top: 60px">
              <p style="font-size: 16px; font-weight: 600">
                {{ $t('center.shopee_master') }} - {{ $t('center.competitive_products') }}
              </p>
              <el-table :data="competing_product_filter_list" @sort-change="m__competing_sort_change">
                <el-table-column width="60px" fixed="left">
                  <template slot-scope="scope">
                    <img :src="SHOPEE_IMAGE(scope.row.image)" alt="logo"
                         style="width:45px; height: 45px; object-fit: contain">
                  </template>
                </el-table-column>
                <el-table-column :label="$t('base.product')" show-tooltip-when-overflow width="350px">
                  <template slot-scope="scope">
                    <a href="javascript:void(0)"
                       @click="open_link_fixed(`https://shopee.com/product-i.${scope.row.shopid}.${scope.row.itemid}`, shop)">
                      {{ scope.row.title }}
                    </a>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('base.price')" prop="price" sortable="custom">
                  <template slot-scope="scope">
                    {{ scope.row.price / 100000 | currency }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('base.monthly_sales')" prop="units_sold" sortable="custom">
                  <template slot-scope="scope">
                    {{ scope.row.units_sold | currency }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('base.monthly_gmv')" prop="gmv_month" sortable="custom">
                  <template slot-scope="scope">
                    {{ scope.row.gmv_month | currency }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>

      <div v-if="tab === 'by_shop'">
        <el-row style="margin-top: 40px;">
          <el-col :sm="10">
            <div style="display: inline-block; margin-right: 10px">
              <shop-select v-model="shopee_shop.selected" :shopee_shop_list="shopee_shop.list"
                           :disabled="loading.get_data || loading.buy_together || loading.all_data"></shop-select>
            </div>
          </el-col>
          <el-col :sm="14" class="text-right">
            <div v-if="shop && shop.extra_data && shop.extra_data.linked && shop.extra_data.sync"
                 style="font-size: 15px; font-weight: 700;" class="text-primary">
              <i class="el-icon-loading"></i> {{ $t('center.shop_in_sync_orders_process') }}...
            </div>
          </el-col>
        </el-row>

        <div style="margin-top: 50px">
          <div v-if="!shop._id"
               style="width: 100%; height: 60px; line-height: 56px; border: 2px solid #ccccd6; border-radius: 50px; text-align: center; font-size: 15px; font-weight: 700;">
            {{ $t('center.select_shop_to_use_feature') }}.
          </div>

          <div v-else-if="shop.extra_data && !shop.extra_data.linked"
               style="width: 100%; height: 60px; line-height: 56px; border: 2px solid #ccccd6; border-radius: 50px; text-align: center; font-size: 15px; font-weight: 700;">
            {{ $t('center.shop_need_to_link') }}.
            <a href="javascript:void(0)" style="font-size: 15px; text-decoration: underline !important;"
               @click="m__get_login">
              {{ $t('center.link_account') }}.</a>
          </div>

          <div v-else-if="loading.get_data"
               style="width: 100%; height: 60px; line-height: 56px; border: 2px solid #ccccd6; border-radius: 50px; text-align: center; font-size: 15px; font-weight: 700;">
            <i class="el-icon-loading"></i> {{ $t('center.analyzing_data') }}...
          </div>

          <div v-else>
            <el-row style="margin-top: 50px;">
              <el-col :sm="24">
                <div style="display: inline-block; margin-right: 10px">
                  <strong style="font-size: 13px">{{ $t('select.time_period_for_analysis') }}</strong>
                  <br>
                  <br>
                  <el-select size="small" value="" filterable="" v-model="selected_period_all"
                             :placeholder="$t('input.time')" :disabled="loading.all_data">
                    <el-option value="year" :label="$t('center.since_begin_year')"></el-option>
                    <el-option value="month" :label="$t('center.since_begin_month')"></el-option>
                    <el-option value="year_only" :label="$t('center.only_in_year')"></el-option>
                    <el-option value="month_only" :label="$t('center.only_in_month')"></el-option>
                    <el-option value="all" :label="$t('center.up_to_now')"></el-option>
                    <el-option value="month_range" :label="$t('center.from_month_to_month')"></el-option>
                    <el-option value="past1week" :label="$t('base.past1week')"></el-option>
                    <el-option value="past1month" :label="$t('base.past1month')"></el-option>
                  </el-select>
                </div>
                <div v-if="!array_to_set(['past1week', 'past1month']).has(selected_period)"
                     style="display: inline-block; margin-right: 10px">
                  <el-date-picker
                    v-model="period_value_all"
                    :type="period_format[selected_period_all].key"
                    :format="period_format[selected_period_all].format"
                    :picker-options="{firstDayOfWeek: 1}"
                    :placeholder="$t('input.select_time')"
                    :start-placeholder="$t('input.start_time')"
                    end-:placeholder="$t('base.select_end_time')"
                    size="small"
                    :disabled="loading.get_data || loading.all_data || selected_period_all === 'all'">
                  </el-date-picker>
                </div>
                <el-button size="small" type="primary" icon="el-icon-search" :loading="loading.all_data"
                           @click="m__get_all_data">{{ $t('base.analyze_data') }}
                </el-button>
              </el-col>
            </el-row>

            <div style="margin-top: 60px">
              <el-row style="margin-bottom: 10px">
                <el-col :sm="20">
                  <p style="font-size: 16px; font-weight: 600">{{ $t('center.shop_analysis_by_city') }}</p>
                </el-col>
                <el-col :sm="4">
                  <el-input size="mini" v-model="top_by_state_all_filter.keyword"
                            :placeholder="$t('input.placeholder')"></el-input>
                </el-col>
              </el-row>
              <el-table :data="top_by_state_all_display_list" v-loading="loading.all_data"
                        @sort-change="m__top_state_all_sort_change">
                <el-table-column :label="$t('center.province_city')" prop="state">
                  <template slot-scope="scope">
                    {{ scope.row.state }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('base.sales')" prop="gmv" sortable>
                  <template slot-scope="scope">
                    {{ scope.row.gmv | currency }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('base.buyers')" prop="buyers" sortable="custom">
                  <template slot-scope="scope">
                    {{ scope.row.buyers | currency }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('center.return_buyers')" prop="exist_buyers" sortable="custom">
                  <template slot-scope="scope">
                    {{ scope.row.exist_buyers | currency }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('center.order_number')" prop="orders" sortable="custom">
                  <template slot-scope="scope">
                    {{ scope.row.orders | currency }}
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                :current-page.sync="top_by_state_all_filter.current_page"
                :page-size="top_by_state_all_filter.page_size"
                layout="total, prev, pager, next"
                :total="top_by_state_all_filter_list.length">
              </el-pagination>
            </div>

            <div style="margin-top: 60px">
              <p style="font-size: 16px; font-weight: 600">{{ $t('center.shop_analysis_by_period') }}</p>
              <el-table :data="top_by_hour_all" v-loading="loading.all_data">
                <el-table-column :label="$t('base.period')">
                  <template slot-scope="scope">
                    {{ scope.row.label }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('base.sales')" prop="gmv" sortable>
                  <template slot-scope="scope">
                    {{ scope.row.gmv | currency }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('base.buyers')" prop="buyers" sortable>
                  <template slot-scope="scope">
                    {{ scope.row.buyers | currency }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('center.order_number')" prop="orders" sortable>
                  <template slot-scope="scope">
                    {{ scope.row.orders | currency }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="show_dialog.select_product" :close-on-click-modal="false" width="1100px">
      <div slot="title" style="padding:10px">
        <el-row style="margin: 10px 0">
          <el-col :sm="18">
            <strong v-if="loading.get_product" class="strong-title">
              <i class="el-icon-loading" style="font-size: 14px"></i> {{ $t('base.loading_products') }}
            </strong>
            <strong v-else class="strong-title">{{ $t('center.select_product_to_analyze') }}</strong>
          </el-col>
          <el-col :sm="6">
            <el-input size="mini" v-model="product_filter.keyword" :placeholder="$t('input.placeholder')"></el-input>
          </el-col>
        </el-row>

        <el-table :data="product_display_list" @sort-change="m__product_sort_change">
          <el-table-column :label="$t('base.product')" width="80px" fixed="left">
            <template slot-scope="scope">
              <img :src="SHOPEE_IMAGE(scope.row.images[0])" alt="logo"
                   style="width:56px; height: 56px;">
            </template>
          </el-table-column>
          <el-table-column width="300px" show-tooltip-when-overflow fixed="left">
            <template slot-scope="scope">
              <a href="javascript:void(0);"
                 @click="open_link_fixed(`https://shopee.com/product-i.${shop.shop_id}.${scope.row.id}`, shop)">
                {{ scope.row.name }}
              </a>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.price')" prop="price" sortable="custom">
            <template slot-scope="scope">
              <span>{{ +scope.row.price ? +scope.row.price : scope.row.price_before_discount | currency }}đ</span> <br>
              <span v-if="+scope.row.price" style="text-decoration: line-through; color: #999">{{
                  scope.row.price_before_discount | currency
                }}đ</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.stock')" prop="models_stock" sortable="custom">
          </el-table-column>
          <el-table-column :label="$t('center.add_to_cart_units_30_days')" prop="add_to_cart_units" sortable="custom">
          </el-table-column>
          <el-table-column :label="$t('center.items_sold_30_days')" prop="sold" sortable="custom">
          </el-table-column>
          <el-table-column :label="$t('center.sales_30_days')" prop="gmv" sortable="custom">
            <template slot-scope="scope">
              {{ scope.row.gmv | currency }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.optional')">
            <template slot-scope="scope">
              <el-button size="small" type="primary" @click="m__select_product(scope.row)">

                {{ $t('base.select') }} <i class="el-icon-arrow-right"></i></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page.sync="product_filter.current_page"
          :page-size="product_filter.page_size"
          layout="total, prev, pager, next"
          :total="product_filter_list.length">
        </el-pagination>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.model_list" :close-on-click-modal="false" width="400px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.variation_list') }}</strong>
        <el-table :data="model_list">
          <el-table-column prop="model_name" :label="$t('base.variation_name')"></el-table-column>
          <el-table-column prop="count" :label="$t('center.purchased_number')" align="right"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {drop as _drop, filter as _filter, take as _take, orderBy as _orderBy, chunk as _chunk} from 'lodash'
import {check_feature, show_expr_notification} from '../../addon/check_license'
import {make_uuid} from "../../addon/ads_function";
import {replace_buy_together, replace_get_top_hour, replace_get_top_state} from '../../addon/_replace'
import {get_shop_mixins} from "../../mixins/get_shop";
import {fix_ads_mixins} from "../../mixins/fix_ads";

export default {
  name: 'page__shop-order',

  mixins: [get_shop_mixins, fix_ads_mixins],

  data() {
    return {
      seller: {},
      shop: {},
      loading: {
        get_data: false,
        buy_together: false,
        all_data: false,
        get_product: false
      },

      top_by_gmv: [],
      top_by_buyers: [],
      top_by_hour: [],
      top_by_state: [],
      top_by_hour_all: [],
      top_by_state_all: [],
      product_together_list: [],
      product_list: [],
      selected_product_id: null,
      selected_period: 'year',
      selected_period_all: 'year',
      period_value: this.dayjs().subtract(1, 'year').startOf('year').toDate(),
      period_value_all: this.dayjs().subtract(1, 'year').startOf('year').toDate(),
      period_format: {
        year: {
          key: 'year',
          format: ''
        },
        month: {
          key: 'month',
          format: ''
        },
        year_only: {
          key: 'year',
          format: ''
        },
        month_only: {
          key: 'month',
          format: ''
        },
        month_range: {
          key: 'monthrange',
          format: 'MM-yyyy'
        },
        all: '',
        day: 'dd-MM-yyyy',
        past1week: '',
        past1month: '',
        from_to: {
          key: 'daterange',
          format: 'dd-MM-yyyy'
        },
      },

      top_by_state_filter: {
        page_size: 10,
        current_page: 0,
        keyword: ''
      },
      top_by_state_all_filter: {
        page_size: 10,
        current_page: 0,
        keyword: ''
      },
      buy_together_filter: {
        page_size: 10,
        current_page: 0,
        keyword: ''
      },
      buy_together_sort_option: {
        order: null,
        prop: null
      },
      top_state_sort_option: {
        order: null,
        prop: null
      },
      top_state_all_sort_option: {
        order: null,
        prop: null
      },
      product_sort_option: {
        order: null,
        prop: null
      },
      selected_product: {
        name: '',
        image: '',
        stock: 0,
        sold: 0,
        gmv: 0,
        impression: 0
      },
      product_filter: {
        page_size: 10,
        current_page: 0,
        keyword: ''
      },
      show_dialog: {
        select_product: false,
        model_list: false
      },
      tab: 'by_product',
      model_list: [],
      competing_product_list: [],
      competing_sort_option: {
        order: null,
        prop: null
      },

      selected_model_list: [],
      show_full_model_field: false
    }
  },

  beforeRouteEnter(to, from, next) {
    if (check_feature('order_center')) {
      next()
    } else {
      show_expr_notification()
      next('/')
    }
  },

  async beforeMount() {
    await this.m__get_shopee_shop()
  },

  computed: {
    top_5_by_gmv() {
      return _orderBy(this.product_together_list, ['gmv'], ['desc']).splice(0, 5)
    },

    top_5_by_buyers() {
      return _orderBy(this.product_together_list, ['buyers'], ['desc']).splice(0, 5)
    },

    product_together_filter_list() {
      let result = this.product_together_list

      if (this.buy_together_sort_option.order) {
        this.buy_together_sort_option.order === 'ascending' && (result = _orderBy(result, [this.buy_together_sort_option.prop], ['asc']))
        this.buy_together_sort_option.order === 'descending' && (result = _orderBy(result, [this.buy_together_sort_option.prop], ['desc']))
      }

      const words = this.remove_unicode(this.buy_together_filter.keyword)
      return _filter(result, item => this.remove_unicode(JSON.stringify(item)).includes(words))
    },

    product_together_display_list() {
      const limit = this.buy_together_filter.page_size
      const skip = limit * (this.buy_together_filter.current_page - 1)

      return _take(_drop(this.product_together_filter_list, skip), limit)
    },

    top_by_state_filter_list() {
      let result = this.top_by_state

      if (this.top_state_sort_option.order) {
        this.top_state_sort_option.order === 'ascending' && (result = _orderBy(result, [this.top_state_sort_option.prop], ['asc']))
        this.top_state_sort_option.order === 'descending' && (result = _orderBy(result, [this.top_state_sort_option.prop], ['desc']))
      }

      const words = this.remove_unicode(this.top_by_state_filter.keyword)
      return _filter(result, item => this.remove_unicode(JSON.stringify(item)).includes(words))
    },

    top_by_state_display_list() {
      const limit = this.top_by_state_filter.page_size
      const skip = limit * (this.top_by_state_filter.current_page - 1)

      return _take(_drop(this.top_by_state_filter_list, skip), limit)
    },

    top_by_state_all_filter_list() {
      let result = this.top_by_state_all

      if (this.top_state_all_sort_option.order) {
        this.top_state_all_sort_option.order === 'ascending' && (result = _orderBy(result, [this.top_state_all_sort_option.prop], ['asc']))
        this.top_state_all_sort_option.order === 'descending' && (result = _orderBy(result, [this.top_state_all_sort_option.prop], ['desc']))
      }

      const words = this.remove_unicode(this.top_by_state_all_filter.keyword)
      return _filter(result, item => this.remove_unicode(JSON.stringify(item)).includes(words))
    },

    top_by_state_all_display_list() {
      const limit = this.top_by_state_all_filter.page_size
      const skip = limit * (this.top_by_state_all_filter.current_page - 1)

      return _take(_drop(this.top_by_state_all_filter_list, skip), limit)
    },

    product_filter_list() {
      let result = this.product_list

      if (this.product_sort_option.order) {
        this.product_sort_option.order === 'ascending' && (result = _orderBy(result, [this.product_sort_option.prop], ['asc']))
        this.product_sort_option.order === 'descending' && (result = _orderBy(result, [this.product_sort_option.prop], ['desc']))
      }

      const words = this.remove_unicode(this.product_filter.keyword)
      return _filter(result, item => this.remove_unicode(item.name.normalize()).includes(words))
    },

    product_display_list() {
      const limit = this.product_filter.page_size
      const skip = limit * (this.product_filter.current_page - 1)

      return _take(_drop(this.product_filter_list, skip), limit)
    },

    competing_product_filter_list() {
      let result = this.competing_product_list

      if (this.competing_sort_option.order) {
        this.competing_sort_option.order === 'ascending' && (result = _orderBy(result, [this.competing_sort_option.prop], ['asc']))
        this.competing_sort_option.order === 'descending' && (result = _orderBy(result, [this.competing_sort_option.prop], ['desc']))
      }

      return result
    }
  },

  watch: {
    'shopee_shop.selected': function () {
      this.m__initial_view()
    }
  },

  methods: {
    m__competing_sort_change({
                               prop,
                               order
                             }) {
      this.competing_sort_option.order = order
      this.competing_sort_option.prop = prop
    },

    async m__get_product_detail(itemid, shopid) {
      const response = await this.request_to_shopee({
        url: `https://shopee.vn/api/v4/item/get?itemid=${itemid}&shopid=${shopid}`
      })
      if (response.body.data && response.body.data.data) {
        return response.body.data.data
      }

      return null
    },

    async get_competing_products() {
      this.competing_product_list = []

      try {
        const competing_resp = await this.seller.seller_competing_products(this.selected_product_id, this.selected_product.category_path[1], this.selected_product.category_path[2])
        for (const item of competing_resp.data.result) {
          item.gmv_month = item.price / 100000 * item.units_sold
        }
        this.competing_product_list = competing_resp.data.result
      } catch (e) {
        console.error(e)
      }
    },

    m__show_models(data) {
      this.model_list = data.models
      this.show_dialog.model_list = true
    },

    async m__select_product(product) {
      this.show_full_model_field = false
      this.selected_model_list = []
      this.selected_product_id = product.id

      const products_detail = await this.seller.get_product_by_graphql([product.id.toString()])

      if (products_detail.data.products.items) {
        this.selected_model_list = products_detail.data.products.items[0].modelList.map(i => {
          i.checked = true
          i.count = 0
          i.gmv = 0
          i.aov = 0
          return i
        })
        this.selected_model_list = _orderBy(this.selected_model_list, ['normalStock'], ['desc'])
      }

      this.selected_product.itemid = product.itemid
      this.selected_product.name = product.name
      this.selected_product.image = product.images[0]
      this.selected_product.stock = product.stock || product.models_stock
      this.selected_product.sold = product.sold || product.models_sold
      this.selected_product.gmv = product.gmv
      this.selected_product.impression = product.view_count
      this.selected_product.category_path = product.category_path

      this.show_dialog.select_product = false
      // console.log(product)
    },

    m__get_reduce_prop(product, prop) {
      if (product.model_list && product.model_list.length) {
        if (prop === 'stock') {
          return product.model_list.reduce((total, item) => {
            return total + item.stock_detail.total_available_stock || 0
          }, 0)
        } else if (prop === 'gmv') {
          return product.model_list.reduce((total, item) => {
            return total + (item.sold * +item.price_info.promotion_price)
          }, 0)
        } else {
          return product.model_list.reduce((total, item) => {
            return total + item[prop] || 0
          }, 0)
        }
      } else {
        return 0
      }
    },

    m__product_sort_change({
                             prop,
                             order
                           }) {
      this.product_sort_option.order = order
      this.product_sort_option.prop = prop
    },

    m__buy_together_sort_change({
                                  prop,
                                  order
                                }) {
      this.buy_together_sort_option.order = order
      this.buy_together_sort_option.prop = prop
    },

    m__top_state_sort_change({
                               prop,
                               order
                             }) {
      this.top_state_sort_option.order = order
      this.top_state_sort_option.prop = prop
    },

    m__top_state_all_sort_change({
                                   prop,
                                   order
                                 }) {
      this.top_state_all_sort_option.order = order
      this.top_state_all_sort_option.prop = prop
    },

    async m__get_login() {
      const resp = await this.$http.post('https://api.atosa.asia/api/v1/open-platform/', {
        name: '',
        channel: 'open_platform_shopee',
        redirect_url: `${window.location.origin}/shop`
      }, this.cf())

      if (resp && resp.body && resp.body.data && resp.body.data.url) {
        window.open(resp.body.data.url, '_blank')
      }
    },

    async m__initial_view() {
      try {
        if (this.shopee_shop.selected.length > 6) {
          const items = this.shopee_shop.list.filter(e => e._id === this.shopee_shop.selected)
          if (items.length > 0) {
            const shop = items[0]

            if (!this.check_role(shop, 'marketing', 'order_center')) {
              this.shopee_shop.selected = ''
              return
            }

            this.shop = shop
            this.seller = await this.init_seller(shop)

            if (!await this.check_shop(this.seller)) {
              this.shopee_shop.selected = ''
              this.product_list = []
              return
            }

            const json_data = await this.seller.get_shop_info()
            try {
              let current_info = json_data.data
              if (!current_info.shopid) {
                await this.seller.seller_login()
                await this.m__get_shopee_shop()
                const shop = this.shopee_shop.list.find(i => i._id === this.shopee_shop.selected)
                this.seller.cookie = shop.cookie
                this.shop = shop
              }
            } catch (e) {
              await this.seller.seller_login()
              await this.m__get_shopee_shop()
              const shop = this.shopee_shop.list.find(i => i._id === this.shopee_shop.selected)
              this.seller.cookie = shop.cookie
              this.shop = shop
            }

            this.ntf_s(`${this.$t('shop.connected_to')}: ${this.shop.username}`)

            this.loading.get_data = true

            this.m__get_products().catch(console.error)

            this.loading.get_data = false
          }
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(`${this.$t('shop.connect_shop_error')}: ${this.shop.username}`)
      } finally {
      }
    },

    async m__get_products() {
      this.loading.get_product = true
      this.product_list = []

      const cache_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/cache/get_all_products', {
        shop_id: this.shop.shop_id
      }, this.cf())

      const product_cache_list = cache_response && cache_response.body && cache_response.body.data && cache_response.body.data.length
        ? typeof cache_response.body.data === 'string' ? JSON.parse(cache_response.body.data) : cache_response.body.data
        : []

      if (product_cache_list.length > 100) {
        const chunk_list = _chunk(product_cache_list, 20)
        for (const chunk of chunk_list) {
          await this.sleep(500)

          const product_ids = chunk.map(i => i.id.toString())
          const product_detail_list = []

          // todo: get cache data
          const products_by_graphql_cache_cache_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/cache/get_products_by_graphql', {
            shop_id: this.shop.shop_id,
            product_ids: product_ids
          }, this.cf())
          if (products_by_graphql_cache_cache_response && products_by_graphql_cache_cache_response.body && products_by_graphql_cache_cache_response.body.data) {
            const data = typeof products_by_graphql_cache_cache_response === 'string'
              ? JSON.parse(products_by_graphql_cache_cache_response.body.data)
              : products_by_graphql_cache_cache_response.body.data
            product_detail_list.push(...data.map(i => JSON.parse(i.response)))
          }

          // todo: get missing cache data
          if (product_detail_list.length < chunk.length) {
            const founded_product_ids_set = new Set(product_detail_list.map(i => i.itemid.toString()))
            const missing_product_id = chunk.filter(i => !founded_product_ids_set.has(i.id.toString())).map(i => i.id.toString())
            const products_detail = await this.seller.get_product_by_graphql(missing_product_id)
            if (products_detail && products_detail.data && products_detail.data.products && products_detail.data.products.items) {
              product_detail_list.push(...products_detail.data.products.items)
            }
          }

          for (const item of chunk) {
            const product_detail = product_detail_list.find(i => i.itemid === item.id.toString())
            item.images = product_detail.images
            item.price = item.model_list && item.model_list.length && item.model_list[0].price_info ? +item.model_list[0].price_info.promotion_price : 0
            item.price_before_discount = item.model_list && item.model_list.length && item.model_list[0].price_info ? +item.model_list[0].price_info.normal_price : 0
            item.checked = false
            item.models_stock = this.m__get_reduce_prop(item, 'stock')
            item.models_sold = this.m__get_reduce_prop(item, 'sold')
            item.gmv = 0
            item.add_to_cart_units = 0
            item.performance = {
              pv: 0,
              add_to_cart_units: 0,
              confirmed_units: 0,
              confirmed_sales: 0,
              pv_to_add_to_cart_rate: 0,
              add_to_cart_to_confirmed_units_rate: 0
            }
          }
          this.product_list.push(...chunk)
        }

        console.log('loaded products from cache')
      } else {
        let page_index = 1
        let products_resp = await this.seller.get_product_by_page(page_index)
        while (products_resp.length) {
          const product_ids = products_resp.map(i => i.id.toString())
          const products_detail = await this.seller.get_product_by_graphql(product_ids)

          for (const item of products_resp) {
            const product_detail = products_detail.data.products.items.find(i => i.itemid === item.id.toString())
            item.images = product_detail.images
            item.price = item.model_list && item.model_list.length && item.model_list[0].price_info ? +item.model_list[0].price_info.promotion_price : 0
            item.price_before_discount = item.model_list && item.model_list.length && item.model_list[0].price_info ? +item.model_list[0].price_info.normal_price : 0
            item.checked = false
            item.models_stock = this.m__get_reduce_prop(item, 'stock')
            item.models_sold = this.m__get_reduce_prop(item, 'sold')
            item.gmv = 0
            item.add_to_cart_units = 0
            item.performance = {
              pv: 0,
              add_to_cart_units: 0,
              confirmed_units: 0,
              confirmed_sales: 0,
              pv_to_add_to_cart_rate: 0,
              add_to_cart_to_confirmed_units_rate: 0
            }
          }
          this.product_list.push(...products_resp)
          products_resp = await this.seller.get_product_by_page(page_index + 1)
          page_index++
        }
      }

      const start_time = this.dayjs().subtract(30, 'd').startOf('d').unix()
      const end_time = this.dayjs().startOf('d').unix()
      const product_performance = []
      let page = 1, page_size = 20
      let product_performance_resp = await this.seller.get_product_performance_main(page, page_size, start_time, end_time, 'past30days')

      while (product_performance_resp && product_performance_resp.data && product_performance_resp.data.result &&
      product_performance_resp.data.result.items && product_performance_resp.data.result.items.length) {
        if (product_performance.length > product_performance_resp.data.result.total) {
          return
        }

        for (const item of product_performance_resp.data.result.items) {
          item.pv_to_add_to_cart_rate = +item.pv ? parseFloat((item.add_to_cart_units / item.pv * 100).toFixed(2)) : 0
          item.add_to_cart_to_confirmed_units_rate = +item.add_to_cart_units ? parseFloat((item.confirmed_units / item.add_to_cart_units * 100).toFixed(2)) : 0
        }

        product_performance.push(...product_performance_resp.data.result.items)
        page++
        product_performance_resp = await this.seller.get_product_performance_main(page, page_size, start_time, end_time, 'past30days')
      }

      for (const item of product_performance) {
        const product_found = this.product_list.find(i => i.id === item.id)
        if (product_found) {
          product_found.performance = item
          product_found.add_to_cart_units = item.add_to_cart_units
          product_found.sold = item.confirmed_units
          product_found.gmv = item.confirmed_sales
        }
      }

      this.product_list = this.clone(_orderBy(this.product_list, ['gmv'], ['desc']))

      this.loading.get_product = false
    },

    async m__get_data() {
      if (!this.selected_product_id) {
        this.show_dialog.select_product = true
        this.ntf_w(this.$t('required.select_product_to_analyze'))
        return
      }
      if (this.selected_period !== 'all' && !this.period_value) {
        this.ntf_w(this.$t('required.select_duration'))
        return
      }

      if (this.selected_period === 'month_range' && (!this.period_value[0] || !this.period_value[1])) {
        this.ntf_w(this.$t('required.select_duration'))
        return
      }

      this.loading.buy_together = true

      let start_time = 0, end_time = 0
      if (this.selected_period === 'year') {
        start_time = this.dayjs(this.period_value).startOf('year').unix()
      }
      if (this.selected_period === 'month') {
        start_time = this.dayjs(this.period_value).startOf('month').unix()
      }
      if (this.selected_period === 'year_only') {
        start_time = this.dayjs(this.period_value).startOf('year').unix()
        end_time = this.dayjs(this.period_value).endOf('year').unix()
      }
      if (this.selected_period === 'month_only') {
        start_time = this.dayjs(this.period_value).startOf('month').unix()
        end_time = this.dayjs(this.period_value).endOf('month').unix()
      }
      if (this.selected_period === 'month_range') {
        start_time = this.dayjs(this.period_value[0]).startOf('month').unix()
        end_time = this.dayjs(this.period_value[1]).endOf('month').unix()
      }
      if (this.selected_period === 'past1week') {
        start_time = this.dayjs().subtract(1, 'week').subtract(1, 'day').startOf('d').unix()
        end_time = this.dayjs().subtract(1, 'day').endOf('day').unix()
      }
      if (this.selected_period === 'past1month') {
        start_time = this.dayjs().subtract(1, 'month').subtract(1, 'day').startOf('d').unix()
        end_time = this.dayjs().subtract(1, 'day').endOf('day').unix()
      }
      if (this.selected_period === 'from_to') {
        start_time = this.dayjs(this.period_value[0]).startOf('day').unix()
        end_time = this.dayjs(this.period_value[1]).endOf('day').unix()
      }

      try {
        await Promise.all([
          this.m__get_buy_together(start_time, end_time),
          this.m__get_top_state(start_time, end_time),
          this.m__get_top_hour(start_time, end_time)
        ])

        this.get_competing_products().catch(console.error)
      } catch (e) {
        console.error(e)
        this.ntf_e(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.buy_together = false
      }
    },

    async m__get_all_data() {
      this.loading.all_data = true

      if (this.selected_period_all !== 'all' && !this.period_value_all) {
        this.ntf_w(this.$t('required.select_duration'))
        return
      }

      if (this.selected_period_all === 'month_range' && (!this.period_value_all[0] || !this.period_value_all[1])) {
        this.ntf_w(this.$t('required.select_duration'))
        return
      }

      let start_time = 0, end_time = 0
      if (this.selected_period_all === 'year') {
        start_time = this.dayjs(this.period_value_all).startOf('year').unix()
      }
      if (this.selected_period_all === 'month') {
        start_time = this.dayjs(this.period_value_all).startOf('month').unix()
      }
      if (this.selected_period_all === 'year_only') {
        start_time = this.dayjs(this.period_value_all).startOf('year').unix()
        end_time = this.dayjs(this.period_value_all).endOf('year').unix()
      }
      if (this.selected_period_all === 'month_only') {
        start_time = this.dayjs(this.period_value_all).startOf('month').unix()
        end_time = this.dayjs(this.period_value_all).endOf('month').unix()
      }
      if (this.selected_period_all === 'month_range') {
        start_time = this.dayjs(this.period_value_all[0]).startOf('month').unix()
        end_time = this.dayjs(this.period_value_all[1]).endOf('month').unix()
      }
      if (this.selected_period_all === 'past1week') {
        start_time = this.dayjs().subtract(1, 'week').subtract(1, 'day').startOf('d').unix()
        end_time = this.dayjs().subtract(1, 'day').endOf('day').unix()
      }
      if (this.selected_period_all === 'past1month') {
        start_time = this.dayjs().subtract(1, 'month').subtract(1, 'day').startOf('d').unix()
        end_time = this.dayjs().subtract(1, 'day').endOf('day').unix()
      }

      try {
        await Promise.all([
          this.m__get_top_state_all(start_time, end_time),
          this.m__get_top_hour_all(start_time, end_time)
        ])
      } catch (e) {
        console.error(e)
        this.ntf_e(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.all_data = false
      }
    },

    async m__get_buy_together(start_time, end_time) {
      this.product_together_list = []

      const buy_together_resp = await this.$http.post(this.API.URL_API_SRV_2 + '/shopee/buy_together', {
        shop_id: this.shop.shop_id,
        item_id: this.selected_product_id,
        period: this.selected_period,
        start_time: start_time,
        end_time: end_time,
        model_ids: this.selected_model_list.length > 1 && this.selected_model_list.filter(i => i.checked).length !== this.selected_model_list.length
          ? this.selected_model_list.filter(i => i.checked).map(i => i.modelid)
          : [],
        all_model_ids: this.selected_model_list.map(i => i.modelid)
      }, this.cf())

      replace_buy_together(this.seller, buy_together_resp)

      for (const item of _orderBy(buy_together_resp.body.data, ['count'], ['desc'])) {
        let product_found = this.product_list.find(i => i.id === item.item_id)
        if (product_found) {
          product_found = this.clone(product_found)
          product_found.id = make_uuid()
          product_found.item_id = item.item_id
          product_found.buy_together = item.count
          product_found.gmv = item.gmv
          product_found.aov = this.m__calculate(item.gmv / item.count)
          product_found.top_state = item.top_state
          product_found.buyers = item.buyers
          product_found.exist_buyers = item.exist_buyers
          product_found.quantity = item.quantity
          product_found.items_per_order = item.items_per_order
          product_found.top_hour = item.top_hour
          product_found.models = []
          product_found.is_parent = true
          product_found.children = item.model_list || []

          for (const child of product_found.children) {
            child.id = make_uuid()
            child.name = child.name || '-'
            child.buy_together = child.count;
            child.aov = this.m__calculate(child.gmv / child.count)
          }

          if (product_found.model_list && product_found.model_list.length > 1) {
            const models = []
            for (const model of product_found.model_list) {
              const filter_list = item.model_ids.filter(i => i === model.id)
              if (filter_list.length) {
                models.push({
                  model_name: model.name,
                  count: filter_list.length
                })
              }
            }
            product_found.models = _orderBy(models, ['count'], ['desc'])
          }

          this.product_together_list.push(product_found)
        }
      }

      for (const item of buy_together_resp.body.models) {
        const model_found = this.selected_model_list.find(i => i.modelid === item.model_id)
        if (model_found) {
          model_found.count = item.count
          model_found.gmv = item.gmv
          model_found.aov = this.m__calculate(item.gmv / item.count)
          model_found.gmv_single = item.gmv_single
          model_found.gmv_together = item.gmv_together
        }
      }
      this.show_full_model_field = true
    },

    async m__get_top_state(start_time, end_time) {
      this.top_by_state = []
      this.top_by_gmv = []
      this.top_by_buyers = []

      const top_state_resp = await this.$http.post(this.API.URL_API_SRV_2 + '/shopee/top_state', {
        shop_id: this.shop.shop_id,
        item_id: this.selected_product_id,
        period: this.selected_period,
        start_time: start_time,
        end_time: end_time,
        model_ids: this.selected_model_list.length > 1 && this.selected_model_list.filter(i => i.checked).length !== this.selected_model_list.length
          ? this.selected_model_list.filter(i => i.checked).map(i => i.modelid)
          : []
      }, this.cf())

      replace_get_top_state(this.seller, top_state_resp)

      this.top_by_state = top_state_resp.body.data.top_by_state
      this.top_by_gmv = top_state_resp.body.data.top_by_gmv
      this.top_by_buyers = top_state_resp.body.data.top_by_buyers
    },

    async m__get_top_state_all(start_time, end_time) {
      this.top_by_state_all = []

      const top_state_resp = await this.$http.post(this.API.URL_API_SRV_2 + '/shopee/top_state/all', {
        shop_id: this.shop.shop_id,
        item_id: this.selected_product_id,
        period: this.selected_period,
        start_time: start_time,
        end_time: end_time
      }, this.cf())

      this.top_by_state_all = top_state_resp.body.data.top_by_state
    },

    async m__get_top_hour(start_time, end_time) {
      this.top_by_hour = []

      const top_hour_resp = await this.$http.post(this.API.URL_API_SRV_2 + '/shopee/top_hour', {
        shop_id: this.shop.shop_id,
        item_id: this.selected_product_id,
        period: this.selected_period,
        start_time: start_time,
        end_time: end_time,
        model_ids: this.selected_model_list.length > 1 && this.selected_model_list.filter(i => i.checked).length !== this.selected_model_list.length
          ? this.selected_model_list.filter(i => i.checked).map(i => i.modelid)
          : []
      }, this.cf())

      replace_get_top_hour(this.seller, top_hour_resp)

      this.top_by_hour = top_hour_resp.body.data
    },

    async m__get_top_hour_all(start_time, end_time) {
      this.top_by_hour_all = []

      const top_hour_resp = await this.$http.post(this.API.URL_API_SRV_2 + '/shopee/top_hour/all', {
        shop_id: this.shop.shop_id,
        item_id: this.selected_product_id,
        period: this.selected_period,
        start_time: start_time,
        end_time: end_time
      }, this.cf())

      this.top_by_hour_all = top_hour_resp.body.data
    }
  }
}
</script>

<style lang="scss">
.table-hide-expand {
  .el-table__expand-icon--expanded {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/center/order_center.vue